(function planMarketingEffortsForm($, Adzuki)
{
	"use strict";

	var form = {
		name      : 'PlanMarketingEfforts',
		submitted : false,
		serialized: null
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});
	
	
	form.load = function load()
	{
		var $jForm  = $('form[name="' + form.name + '"]');

		$jForm.submit(function formSubmitted(e) {
			form.submitted = true;
		});

		// If a date field is disabled - also disable it's associated hidden field
		// We only submit/process the efforts that are visible. Hidden inputs are disabled
		$('.adzuki-datetimepicker').each(function disableHiddenField(index, el) {
			var hidden_id = null;
			if ($(el).prop('disabled') === true) {
				hidden_id = $(el).prop('id') + '_hidden';
				$('#' + hidden_id).prop('disabled', true);
			}
		});

		// Method for adding a new marketing effort
		$('.add-effort').on('click', function addEffort(e) {
			var curIndex  = parseInt($(this).data('index'));
			var nextIndex = curIndex + 1;

			e.preventDefault();

			$('#effort-box-' + nextIndex).find('input, select, textarea').each(function enableInputs(index, el) {
				$(el).prop('disabled', false);
			});
			$('#effort-box-' + nextIndex).removeClass('hidden');
			$('#add-effort-' + curIndex).addClass('hidden');

			reIndexEfforts();
			showAddEffortLink();
		});

		// hide marketing effort field - disable all its form fields so they won't be submitted to server
		$('.remove-effort').on('click', function removeEffort(e) {
			var curIndex         = parseInt($(this).data('index'));
			// var prevIndex        = curIndex - 1;
			var $effortContainer = $('#effort-box-' + curIndex);

			e.preventDefault();

			Adzuki.CustomConfirm({
				body   : 'Are you sure you want to remove this marketing effort?',
				confirm: function removeMarketingEffort() {
					// clear all the form fields within this div
					$effortContainer.find('input, select, textarea').each(function clearInput(index, el) {
						$(el).val($(el).data('original-value'));
						$(el).prop('disabled', true);
					});
					// hide the form
					$('#effort-box-' + curIndex).addClass('hidden');

					reIndexEfforts();
					showAddEffortLink();
				}
			});
		});

		$('.new_or_existing').on('change', function toggleExistingEffortSelect(e) {
			var index = $(this).data('index');
			if ($(this).val() === 'new') {
				$('#existing-effort-' + index).addClass('hidden');
				$('.new-effort-fields-' + index).removeClass('hidden');

				// hide 'Edit Effort Details' link
				$('#existing-effort-edit-' + index).addClass('hidden');
				$('#planmarketingefforts-effort-' + index + '-update').val('0');
				
				// clear fields
				$('.new-effort-fields-' + index).find('input, select, textarea').each(function clearInput(index, el) {
					if ($(el).hasClass('adzuki-datetimepicker')) {
						$(el).data('DateTimePicker').date(null);
					} else {
						$(el).val($(el).data('original-value'));
					}
				});
			} else {
				$('#existing-effort-' + index).removeClass('hidden');
				$('.new-effort-fields-' + index).addClass('hidden');

				if ($('#planmarketingefforts-effort-' + index + '-id').val() !== '') {
					$('#existing-effort-edit-' + index).removeClass('hidden');
				}
			}
		});

		$('.global_efforts').on('change', function selectGlobalEffort(e) {
			var index     = $(this).data('index');
			var effort_id = $(this).val();

			if (effort_id) {
				Adzuki.Ajax.get('/MarketingEfforts/details/' + effort_id)
				.then(function setEffortDetails(response) {
					$('#planmarketingefforts-effort-' + index + '-effort_name').val(response.name);
					$('#planmarketingefforts-effort-' + index + '-description').val(response.description);
				});
			} else {
				$('#planmarketingefforts-effort-' + index + '-start_date').data('DateTimePicker').clear();
				$('#planmarketingefforts-effort-' + index + '-end_date').data('DateTimePicker').clear();
				$('#planmarketingefforts-effort-' + index + '-effort_name').val('');
				$('#planmarketingefforts-effort-' + index + '-description').val('');
			}
		});

		$('.edit-existing-effort').on('click', showEditExistingEffort);
		$('.existing-effort').on('change', selectedExistingMarketingEffort);

		form.serialized = $jForm.serialize();

		// if user tries to leave this page, besides via a form submission, throw a warning that their info hasn't been saved
		$(window).on('beforeunload', function before() {
			var newSerializedForm = $jForm.serialize();
			if (form.submitted === false && form.serialized !== newSerializedForm) {
				return 'Are you sure you want to leave before finishing your Marketing Plan?';
			}

			return undefined; // do not show dialog if form hasn't changed at all
		});
	};

	// Update the 'Effort 1', 'Effort 2', etc labels. They don't need to match the index of the fields
	function reIndexEfforts() {
		var count = 1;
		$('.marketing-effort-container:visible').each(function updateNumber(index, el) {
			var effortIndex = $(el).data('index');
			$('#effort-index-' + effortIndex).html(count);
			count++;
		});
	}

	// If the last visible effort has another marketing-effort-container after it
	// display the Add Marketing Effort link in last visible container
	function showAddEffortLink() {
		var lastVisibleEffort = $('.marketing-effort-container:visible').last();
		if (lastVisibleEffort.next('.marketing-effort-container')) {
			lastVisibleEffort.find('.add-effort').removeClass('hidden');
		}
	}

	function showEditExistingEffort(ev) {
		// get the id of the existing effort
		var index     = $(this).data('index');
		var effort_id = $('#planmarketingefforts-effort-' + index + '-id').val();

		ev.preventDefault();

		// make ajax request to get details of existing effort
		if (effort_id) {
			Adzuki.Ajax.get('/MarketingEfforts/editDetails/' + effort_id + '/' + index)
			.then(function setEffortDetails(response) {
				var details = $.parseHTML(response);
				$('#effort-details-container-' + index).html($(details).find('#keep-container').html());
				Adzuki.DateTimePicker($('#planmarketingefforts-effort-' + index + '-start_date'));
				Adzuki.DateTimePicker($('#planmarketingefforts-effort-' + index + '-end_date'));
				Adzuki.DragDropUpload.start($(".new-effort-fields-" + index + " .file-upload-options"));
				$('#planmarketingefforts-effort-' + index + '-update').val(1);
				// $('#planmarketingefforts-effort-' + index + '-effort_name').val(response.name);
				// $('#planmarketingefforts-effort-' + index + '-description').val(response.description);
				// $('#planmarketingefforts-effort-' + index + '-budget').val(response.budget);
				// $('#planmarketingefforts-effort-' + index + '-start_date').data('DateTimePicker').date(response.start_date);
				// $('#planmarketingefforts-effort-' + index + '-end_date').data('DateTimePicker').date(response.end_date);
				// $('#planmarketingefforts-effort-' + index + '-update').val(1); // indicates we should update this effort

				$('#existing-effort-edit-' + index).addClass('hidden');
				$('.new-effort-fields-' + index + ':not(.global-template)').removeClass('hidden');
			});
		}
	}

	function selectedExistingMarketingEffort(ev) {
		var index = $(this).data('index');

		ev.preventDefault();

		// the user may have been editing a different existing effort - clear those fields out so they are not used
		// for the newly selected existed marketing effort
		$('.new-effort-fields-' + index).find('input, select, textarea').each(function clearInput(index, el) {
			$(el).val($(el).data('original-value'));
		});

		$('#planmarketingefforts-effort-' + index + '-update').val(0);

		// hide new effort fields
		$('.new-effort-fields-' + index).addClass('hidden');
		$('#existing-effort-edit-' + index).removeClass('hidden');
	}


}(jQuery, window.Adzuki || {}));
